import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseFormComponent } from '../../../../shared/modules/ui/components/abstract/a-base-form.component';
import { FORM_STATE } from '../../../../shared/modules/ui/components/abstract/a-base-model-loader.component';
import { FormHelperService } from '../../../../shared/modules/ui/services/form-helper.service';
import { VehicleService } from '../../../../shared/sdk/models';
import { LoggerService } from '../../../../shared/sdk/services/custom';
import { HelperService } from '../../services/helper.service';
import { take } from 'rxjs/operators';
export class VehicleServiceAddFormComponent extends ABaseFormComponent {
    constructor(logger, fb, dss, config, helper, helperService) {
        super(logger, fb, dss, helper);
        this.logger = logger;
        this.fb = fb;
        this.dss = dss;
        this.config = config;
        this.helper = helper;
        this.helperService = helperService;
        this.SUB_STATUSES = ['Universal', 'Emergency Only', 'Meals Only'];
        // $windowTitle$ = new BehaviorSubject<string>('Change Vehicle Status to “In Maintenance”');
        this.resetableForm = false;
        this.collapsibleForm = false;
        this.selectedVehicle = null;
        this.setState(FORM_STATE.COLLAPSED);
    }
    get ModelClass() {
        return VehicleService;
    }
    get dateFields() {
        return [];
    }
    get filter() {
        return {};
    }
    ngOnInit() {
        const _super = Object.create(null, {
            ngOnInit: { get: () => super.ngOnInit }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            _super.ngOnInit.call(this);
            if (!this.modelId) {
                this.helperService.autoRepairShopDso$.pipe(take(1)).subscribe((shops) => {
                    const affordableShop = shops.find(shop => shop.name.includes('Affordable'));
                    if (affordableShop)
                        this.form.patchValue({ mechanicsShopId: affordableShop.id });
                });
                this.helperService.fleetMechanicsDso$.pipe(take(1)).subscribe((mechanics) => {
                    if (mechanics.length === 1)
                        this.form.patchValue({ mechanicAssignedId: mechanics[0].employee_id });
                });
            }
        });
    }
    // public async validateAsync(): Promise<boolean> {
    //   return !!this.modelId;
    // }
    onVehicleChange(e) {
        if (!e.event)
            return;
        const id = e.value;
        const name = e.event.target.innerText;
        const internalId = +name.split(' -')[0];
        this.form.patchValue({ vehicle: { id, name, internalId } });
        this.helperService.vehicleDso$.pipe(take(1)).subscribe((vehicles) => {
            this.selectedVehicle = vehicles.find(v => v.id === id);
        });
    }
    onMechanicsShopChange(e) {
        if (!e.event)
            return;
        const id = e.value;
        const name = e.event.target.innerText;
        this.form.patchValue({ mechanicsShop: { id, name } });
    }
    onFleetManagerChange(e) {
        if (!e.event)
            return;
        const id = e.value;
        const name = e.event.target.innerText;
        this.form.patchValue({ fleetManagerAssigned: { id, name } });
    }
    onMechanicAssignedChange(e) {
        if (!e.event)
            return;
        const id = e.value;
        const name = e.event.target.innerText;
        this.form.patchValue({ mechanicAssigned: { id, name } });
    }
    buildForm() {
        this.form = this.fb.group({
            id: [null],
            miles: [null],
            vehicleId: [null, Validators.required],
            vehicle: this.fb.group({
                id: [null, Validators.required],
                name: [null, Validators.required],
                internalId: [null, Validators.required],
            }),
            mechanicsShopId: [null],
            mechanicsShop: this.fb.group({ id: [null], name: [null] }),
            dateTimeIn: [null],
            dateTimeOut: [null],
            fleetManagerAssignedId: [null],
            fleetManagerAssigned: this.fb.group({ id: [null], name: [null] }),
            mechanicAssignedId: [null],
            mechanicAssigned: this.fb.group({ id: [null], name: [null] }),
            invoices: this.fb.array([
                this.fb.group({
                    amount: [null, [Validators.required, Validators.min(0)]],
                    description: ['', Validators.required],
                    updatedAt: [null],
                }),
            ]),
        });
    }
    get invoices() {
        return this.form.get('invoices');
    }
    afterSetFormValuesAsync(model, form) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            form.patchValue({
                vehicleId: model.vehicle.id,
                mechanicsShopId: (model.mechanicsShop && model.mechanicsShop.id) || null,
                fleetManagerAssignedId: (model.fleetManagerAssigned && model.fleetManagerAssigned.id) || null,
                mechanicAssignedId: (model.mechanicAssigned && model.mechanicAssigned.id) || null,
            });
            this.helperService.vehicleDso$.pipe(take(1)).subscribe((vehicles) => {
                this.selectedVehicle = vehicles.find(v => v.id === model.vehicle.id);
            });
            if (model.invoices && model.invoices.length > 0) {
                model.invoices.forEach((invoice, index) => {
                    if (this.invoices.at(index)) {
                        this.invoices.at(index).patchValue({
                            amount: invoice.amount,
                            description: invoice.description,
                            updatedAt: invoice.updatedAt,
                        });
                    }
                    else {
                        this.invoices.push(this.fb.group({
                            amount: [invoice.amount, [Validators.required, Validators.min(0)]],
                            description: [invoice.description, Validators.required],
                            updatedAt: [invoice.updatedAt],
                        }));
                    }
                });
            }
        });
    }
    afterSubmittedAsync(data, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () { });
    }
    beforeSubmittingAsync(data) {
        const _super = Object.create(null, {
            beforeSubmittingAsync: { get: () => super.beforeSubmittingAsync }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield _super.beforeSubmittingAsync.call(this, data);
            data.invoices = this.invoices.value;
        });
    }
    onInvoiceChange(index) {
        const invoice = this.invoices.at(index);
        if (invoice)
            invoice.patchValue({ updatedAt: new Date().toISOString() });
    }
    addInvoice() {
        this.invoices.push(this.fb.group({
            amount: [null, [Validators.required, Validators.min(0)]],
            description: ['', Validators.required],
        }));
    }
    removeInvoice(index) {
        this.invoices.removeAt(index);
    }
}
